//import { SplashContainer } from './containers/splash';
import { NotFound } from '../main/routes/not-found';

export default [
    {
        index: true,
        element: <NotFound />,
        //element: <SplashContainer />,
    },
];
